module.exports = __webpack_public_path__ + "img/dyb1.e76c9506.jpg";